/*
 * Project: Bookingengine
 * Module: Payment.js
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import base64 from 'base-64';
import {
  BOOKING_STEP, getBookingDetail, setStep,
} from '../../../actions/Booking';

import PaymentLoading from './PaymentLoading';
import PaymentBooking from './PaymentBooking';
import PaymentBookDetails from './PaymentBookDetails';

import { TPV_FORM_DEFAULT_METHOD } from '../../../constants';

import '../../../static/less/payment.less';
import withNavigate from '../../../withNavigate'; // Importa el HOC

class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      booking: null,
    };
  }

  componentDidMount() {
    const locator = base64.decode(this.props.params.locator);
    const email = base64.decode(this.props.params.email);

    this.props.dispatch(setStep(BOOKING_STEP.NO_AVAIL_STEP));
    this.props.dispatch(getBookingDetail(this.props.lang, locator, 'email', email)).then((r) => {
      this.setState({
        booking: r.booking,
      });
    });
  }

  canPayNow() {
    const { booking } = this.state;
    return booking && booking.status === 'PEND';
  }

  renderPaymentNotPossible(booking) {
    const currency = { ...booking.currency, locale: this.props.lang };
    const msg = this.context.t('This booking has no outstanding payments');
    return (
      <PaymentBookDetails booking={booking} currency={currency} errorMsg={msg} />
    );
  }

  renderPaymentContent(booking) {
    if (this.canPayNow()) {
      return <PaymentBooking formMethod={TPV_FORM_DEFAULT_METHOD} booking={booking} lang={this.props.lang} />;
    }
    return this.renderPaymentNotPossible(booking);
  }

  render() {
    const { booking } = this.state;
    return (
      <div className="Payment container">
        {booking ? this.renderPaymentContent(booking) : <PaymentLoading />}
      </div>
    );
  }
}

Payment.contextTypes = {
  t: PropTypes.func.isRequired,
};

// Conectar el componente con Redux
const mapStateToProps = (state) => ({
  lang: state.i18nState.lang,
});

const ConnectedPayment = connect(mapStateToProps)(Payment);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedPayment);
